import React from "react";
import {
  Form,
  Label,
  Input,
  FormGroup,
  FormFeedback,
  Button
} from "reactstrap";

class CreateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: ""
    };
    this.onInputChange = this.onInputChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onInputChange(e) {
    this.setState({
      [e.target.name]: e.target.value
    });
  }

  onSubmit(e) {
    e.preventDefault();
    const { email } = this.state;
    this.props.forgotPassword(email);
  }

  render() {
    const { authReducer } = this.props;
    const { errors, loading, errorMsg } = authReducer;
    return (
      <div>
        <p className="text-warning text-center f-14">{errorMsg}</p>
        <Form onSubmit={this.onSubmit}>
          <FormGroup>
            <Label for="inputEmail">Email</Label>
            <Input
              type="email"
              name="email"
              id="inputEmail"
              placeholder="carol@gmail.com"
              className="input-group-alternative"
              value={this.state.email}
              onChange={this.onInputChange}
              invalid={!errors.email === false}
            />
            <FormFeedback invalid={errors.email}>{errors.email}</FormFeedback>
          </FormGroup>
          <Button
            type="submit"
            className="w-100 d-block"
            color="primary"
            disabled={loading}
          >
            {loading ? "发送中..." : "重设密码"}
          </Button>
        </Form>
      </div>
    );
  }
}

export default CreateForm;
